import { Token } from '@uniswap/sdk-core'
import { SupportedChainId } from 'constants/chains'

export default {
  weth: new Token(SupportedChainId.ARBITRUM, '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1', 18, 'WETH', 'Wrapped Ether'),
  usdc: new Token(
    SupportedChainId.ARBITRUM,
    '0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8',
    6,
    'USDC',
    'USD Coin (Arb1)'
  ),
  wagmi: new Token(SupportedChainId.FANTOM, '0xC49c177736107fD8351ed6564136B9ADbE5B1eC3', 18, 'WAGMI', 'WAGMI'),
}
